import classNames from 'classnames';
import { uniq } from 'lodash';
import moment from 'moment';
import React from 'react';
import { PermissionsCheck } from '../Components/Auth/PermissionsCheck';
import { Button, ButtonMode } from '../Components/Button';
import { EditIcon, ErrorCircleIcon } from '../Components/Icons';
import { prettyPrintMedicationCourse, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { prettyPrintDosageInstructionLabel, prettyPrintOrderInstructionLabel } from '../Shared/MedicationSharedMethods';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { calculateCourseInstructions } from '../MedicationSummary/Utilities';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { iconLight, red, white } from '../Styles/Colours';
import styles from './FinaliseMedicationErrorTable.module.css';
import { MedicationExpiryType } from '../Shared/Types';
export var FinaliseMedicationErrorTable = function (props) {
    var otherErrors = props.errors.filter(function (it) { return !it.propertyName.startsWith('PatientMedication'); });
    var medErrors = props.errors.filter(function (it) { return it.propertyName.startsWith('PatientMedication'); });
    var medicationsWithErrors = uniq(medErrors.map(function (it) { return it.propertyName.split(':')[1]; }));
    var errors = props.medications
        .filter(function (it) { return medicationsWithErrors.includes(it.id); })
        .map(function (it) { return ({
        medication: it,
        errors: medErrors.filter(function (error) { return error.propertyName.split(':')[1] === it.id; })
    }); });
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.header },
            React.createElement("div", null, "Product"),
            React.createElement("div", null, "Order instructions"),
            React.createElement("div", null, "Type"),
            React.createElement("div", { className: styles.alignRight }, "Start date"),
            React.createElement("div", { className: styles.alignRight }, "End date"),
            React.createElement("div", null)),
        React.createElement("div", { className: styles.body },
            errors.map(function (it) { return (React.createElement("div", { key: it.medication.id, className: styles.row },
                React.createElement(MedicationInformation, { medication: it.medication, errors: it.errors }),
                React.createElement("div", { className: styles.instructionsCell }, calculateCourseInstructions({
                    orderInstructions: it.medication.orderInstruction,
                    dosageInstructions: it.medication.dosageInstruction,
                    type: it.medication.type
                })),
                React.createElement("div", { className: styles.dataCell },
                    React.createElement("div", null, prettyPrintMedicationType(it.medication.type)),
                    React.createElement("div", { className: styles.course }, prettyPrintMedicationCourse(it.medication.course))),
                React.createElement("div", { className: styles.dateCell }, moment(it.medication.performedOn).format(ValidDateFormats.Edit)),
                React.createElement("div", { className: styles.dateCell }, prettyExpiresOn(it.medication)),
                React.createElement("div", { className: styles.actionCell },
                    React.createElement(PermissionsCheck, { key: 'edit-medication', permission: MedicationsPermissions.AccessCode },
                        React.createElement(Button, { iconOnly: true, tooltip: 'Edit', mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: "navigation-edit-" + it.medication.id, onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                props.onView(it.medication.id);
                            } },
                            React.createElement(EditIcon, { color: iconLight, size: '24' })))))); }),
            otherErrors.map(function (it, index) { return (React.createElement("div", { key: it.errorCode + "-" + index, className: classNames(styles.row, styles.errorRow) },
                React.createElement(GeneralError, { message: it.errorMessage }),
                React.createElement("div", { className: styles.dataCell }, "\u00A0"),
                React.createElement("div", { className: styles.dateCell }, "\u00A0"),
                React.createElement("div", { className: styles.dateCell }, "\u00A0"),
                React.createElement("div", { className: styles.actionCell }, "\u00A0"))); }))));
};
var GeneralError = function (props) {
    return (React.createElement("div", { className: styles.generalError },
        React.createElement("div", { className: styles.informationHeader },
            React.createElement("div", { className: styles.icon },
                React.createElement(ErrorCircleIcon, { backgroundColour: red, color: white, size: '40' })),
            React.createElement("div", { className: styles.name }, props.message))));
};
var MedicationInformation = function (props) {
    return (React.createElement("div", { className: styles.information },
        React.createElement("div", { className: styles.informationHeader },
            React.createElement("div", { className: styles.medicationDetails },
                React.createElement("div", { className: styles.name }, props.medication.name),
                React.createElement("div", { className: styles.infoText }, "The medication contains the following issues:"))),
        React.createElement("div", { className: styles.contents },
            React.createElement("ul", { className: styles.errors }, props.errors.map(function (it) { return (React.createElement("li", { key: it.errorCode, className: styles.error }, getErrorMessage(props.medication.type, it.errorMessage, it.errorCode))); })))));
};
function getErrorMessage(medicationType, errorMessage, errorCode) {
    if (errorCode == 'PatientMedication_OrderInstructionsMustHaveTextInstructions')
        return prettyPrintOrderInstructionLabel(medicationType) + ' required';
    else if (errorCode == 'PatientMedication_DosageInstructionsMustHaveTextInstructions')
        return prettyPrintDosageInstructionLabel(medicationType) + ' required';
    return errorMessage;
}
function prettyExpiresOn(medication) {
    if (medication.medicationExpiry === MedicationExpiryType.Chart) {
        return '(Chart duration)';
    }
    else {
        var expiresOn = moment(medication.expiresOn);
        return expiresOn.isValid() ? expiresOn.format(ValidDateFormats.Edit) : '';
    }
}
